module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-andrea-piacquadio-3846559-b29bd6801533f27eb4f4d7f26bd2e4d4.jpg";